export const SpinnerSize = {
    'spinner-small': 'spinner-small',
    'spinner-medium': 'spinner-medium',
    'spinner-large': 'spinner-large',
};

export default function Spinner({size, className}) {
    var spinnerClass = 'loading loading-spinner text-violet-500 mx-auto';

    if (size && size.length > 0) {
        spinnerClass += ' ' + SpinnerSize[size];
    }
    if (className && className.length > 0) {
        spinnerClass += ' ' + className;
    }

    return <div className={'w-full flex'}><span className={spinnerClass}></span></div>;
}
